module.exports = __webpack_public_path__ + "img/7.62b2554e.gif";